export default __webpack_public_path__ + "static/oberon-travelbase-ds-4-c952bd20da851697f46e440b07af835e.jpg";